import React from "react";
import { RouteObject } from "react-router-dom";
import { SUPPORTED_LANGUAGES } from "../../../utils/languageRouting";
import ProfessionalLayout from "../ProfessionalLayout";
import MySettings from "../components/MySettings";
import MyProfile from "../components/MyProfile";
import MyProfile1 from "../../user/components/MyProfile1";
import ProfessionalDashboard from "../../../pages/Main/professionalDashboard";

const baseProfessionalRoutes: RouteObject[] = [
    {
        path: "/professionals",
        element: <ProfessionalLayout />,
        children: [
            { path: "", element: <ProfessionalDashboard /> },
            { path: "myprofile", element: <MyProfile /> },
            { path: "settings", element: <MySettings /> },
        ],
    },
];

/**
 * Create language-prefixed professional routes
 */
const createLanguagePrefixedProfessionalRoutes = (): RouteObject[] => {
    const languagePrefixedRoutes: RouteObject[] = [];
    
    SUPPORTED_LANGUAGES.filter(lang => lang !== "en").forEach(lang => {
        baseProfessionalRoutes.forEach(route => {
            // Add language prefix: /it/professionals
            languagePrefixedRoutes.push({
                ...route,
                path: `/${lang}${route.path}`,
            });
            
            // Also add language suffix: /professionals/it
            languagePrefixedRoutes.push({
                ...route,
                path: `${route.path}/${lang}`,
            });
        });
    });
    
    return languagePrefixedRoutes;
};

const ProfessionalRoutes: RouteObject[] = [
    ...baseProfessionalRoutes,
    ...createLanguagePrefixedProfessionalRoutes(),
];

export default ProfessionalRoutes;